import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import DomainExistingValue from './DomainExistingValue';
import DomainNewValue from './DomainNewValue';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import PropertyInputMultiplePropertyPopoverBody from '../PropertyInputMultiplePropertyPopoverBody';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PopoverContent({
  domains,
  onChangeDomain,
  onAddDomain,
  onRemoveDomain,
  onPromoteDomain,
  showAutoSaveText,
  onExistingDomainInputBlur,
  onExistingDomainInputFocus
}) {
  const [showNewDomainInput, setShowNewDomainInput] = useState(false);
  const handleAddNewDomainInput = () => setShowNewDomainInput(true);
  const handleCancelNewDomainInput = () => setShowNewDomainInput(false);
  const handleSaveNewDomain = newDomain => {
    onAddDomain(newDomain);
    setShowNewDomainInput(false);
  };
  const renderDomainInput = (domain, index) => {
    const isPrimaryDomain = index === 0;
    return /*#__PURE__*/_jsx(ListItem, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(DomainExistingValue, {
        autoFocus: isPrimaryDomain,
        onChange: evt => onChangeDomain(index, evt.target.value),
        showError: true,
        value: domain,
        isPrimaryDomain: isPrimaryDomain,
        onRemoveDomain: onRemoveDomain,
        onPromoteDomain: onPromoteDomain,
        onBlur: onExistingDomainInputBlur,
        onFocus: onExistingDomainInputFocus
      })
    }, index);
  };
  const addNewDomainButton = /*#__PURE__*/_jsxs(UIButton, {
    use: "transparent",
    onClick: handleAddNewDomainInput,
    className: "p-left-0",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "add",
      size: "xxs",
      color: CALYPSO_DARK
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputMultipleDomain.addDomain"
    })]
  });
  return /*#__PURE__*/_jsxs(PropertyInputMultiplePropertyPopoverBody, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputMultipleDomain.label"
      })
    }), /*#__PURE__*/_jsxs(List, {
      children: [domains.map(renderDomainInput), showNewDomainInput && /*#__PURE__*/_jsx(DomainNewValue, {
        domains: domains,
        onSave: handleSaveNewDomain,
        onCancel: handleCancelNewDomainInput,
        showAutoSaveText: showAutoSaveText
      })]
    }), addNewDomainButton]
  });
}
export default PopoverContent;